import * as moment from 'moment';

export default class Review {

    static bless( data: any ) {
        return ( data && new Review(data.head,
                                    data.body,
                                    data.rating,
                                    data.author,
                                    moment(data.ratingDate, 'LL')) );
    }

    constructor( public head: string,
                 public body: string,
                 public rating: number,
                 public author: string,
                 public ratingDate: moment.Moment ) {
    }

}



/** WEBPACK FOOTER **
 ** ./src/models/Review.ts
 **/